import { swalErrorMessage } from "../../../../Constant/swalMessage";
import {
  createDNCService,
  deleteDNCService,
  editDNCService,
  getDNCListService,
  saveDNCListExcelService,
} from "../../services/dnc.services";
import { dncType } from "./dnc.type";

export const getDNCListAction = (params) => async (dispatch) => {
  const res = await getDNCListService(params);
  if (res?.status === 200) {
    if (res?.data?.[0]?.countData) {
      await dispatch({
        type: dncType.GET_DNC_LIST_COUNT,
        payload: res?.data?.[0]?.countData,
      });
    } else {
      await dispatch({
        type: dncType.GET_DNC_LIST,
        payload: res?.data,
      });
    }
    return res?.data;
  }
};

export const createDNCAction = (obj) => async () => {
  const res = await createDNCService(obj);
  if (res.status === 200) {
    return res.status;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const deleteDNCAction = (ids) => async () => {
  const res = await deleteDNCService(ids);
  if (res.status === 200) {
    return res.status;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const editDNCAction = (obj, id) => async () => {
  const res = await editDNCService(obj, id);
  if (res.status === 200) {
    return res.status;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const saveDNCListExcelAction = (obj) => async () => {
  const res = await saveDNCListExcelService(obj);
  if (res?.status === 200) {
    return true;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};
